// extracted by mini-css-extract-plugin
export default {"menu":"pharmacySideMenu_menu__zJcNj"};